// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__868co","avatar":"UserMenu_avatar__3YqSG","name":"UserMenu_name__2hBJw"};